import type { AdditionalOptType } from '../filterTypes';

// V2 names and values from rpjava hotpads-api listing/filter/ListingFilterField.java (read by PermalinkTool).
const OPT_TO_API_PARAM: Record<AdditionalOptType, readonly [string, number | boolean]> = {
  requiresPhotos: ['minPhotos', 1],
  requiresPrice: ['includeVaguePricing', false],
  forRentByOwner: ['isListedByOwner', true],
  hasOffers: ['hasSpecialOffers', true],
  acceptingApplications: ['isAcceptingRentalApplications', true],
};

/**
 * Maps additional options to the V2 API params hotpads-api reads.
 * ['requiresPhotos', 'requiresPrice'] → { minPhotos: 1, includeVaguePricing: false }
 * [] → {}
 */
export function additionalOptsToApiParams(
  opts: Array<AdditionalOptType>,
): Record<string, number | boolean> {
  const params: Record<string, number | boolean> = {};
  for (const opt of opts) {
    const mapping = OPT_TO_API_PARAM[opt];
    if (mapping) {
      const [apiKey, value] = mapping;
      params[apiKey] = value;
    }
  }
  return params;
}
